import { takeLatest, select, call } from 'redux-saga/effects';
import { QueryString, isString } from '@grandvisionhq/utils';
import { logout } from '../auth.js';
import { getBasePath } from '../selectors.js';
import { removeUserDataFromLS } from '../Util/customer-name-persistor.js';
import { LOG_OUT, LOGGED_OUT } from './actions.js';
import { history } from '../Util/history.js';

function* logOut(loggedOut) {
    const basePath = yield select(getBasePath);
    if (!basePath) {
        throw new Error(`Need basePath to generate logout return URI`);
    }
    const logoutPath = `${window.location.protocol}//${location.host}/${basePath}/logged-out?returnPath=${loggedOut.returnPath}`;
    yield call(logout, logoutPath);
}
function* redirectAfterLogOut() {
    yield call(removeUserDataFromLS);
    const { returnPath  } = QueryString.parse(window.location.search);
    const targetPath = isString(returnPath) ? returnPath : '/';
    const historyWrapper = yield call(history);
    try {
        yield call(historyWrapper.replace, {
            pathname: targetPath
        });
        window && window.location.reload();
    } catch (err) {
        console.error(err);
    }
}
var logoutSagas = [
    takeLatest(LOG_OUT, logOut),
    takeLatest(LOGGED_OUT, redirectAfterLogOut), 
];

export { logoutSagas as default, logOut, redirectAfterLogOut };
//# sourceMappingURL=sagas.js.map
